<template>
	<div class="containerq">
		<img class="img" src="@/static/login-bg.jpg" alt="" />
		<div class="content">
			<div class="title" @click="clicktitle">
				<div class="status">[家居学堂]</div>
				<div>富士康肯定是考虑空军第三空间活动开始</div>
			</div>
			<div class="text">的时刻和的授课计划会计恒等式客户看还得几十块和即可获得数据库好几个都是两个健康的返回谁的规划结构好高大上了刚回到公司尽快给大家开始跨境电商高科技但是口感的时刻和的授课计划会计恒等式客户看还得几十块和即可获得数据库好几个都是两个健康的返回谁的规划结构好高大上了刚回到公司尽快给大家开始跨境电商高科技但是口感的结果健康大数据和军队开始看活动开始计划</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['data'],
	methods: {
		clicktitle() {
			console.log(this.data);
			this.$emit('success');
		}
	}
};
</script>

<style lang="less" scoped>
.containerq {
	margin-bottom: 20px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.content {
	display: flex;
	flex-direction: column;
	margin-left: 20px;
	.title {
		cursor: pointer;
		display: flex;
		color: #e96432;
		margin-bottom: 5px;
		.status {
			margin-right: 5px;
			color: blue;
		}
	}
	.text {
		font-size: 12px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2; /* 显示2行 */
		line-clamp: 2; /* 显示2行 */
	}
}
.img {
	width: 70px;
	height: 70px;
	border-radius: 50%;
}
</style>
